import axios from "axios";
import { API_URL } from '../../config/runtimeConfig';
import { addMovementFailure, addMovementStart, addMovementSuccess, getMovementDechargeFailure, getMovementDechargeStart, getMovementDechargeSuccess, getMovementEncaissementFailure, getMovementEncaissementStart, getMovementEncaissementSuccess, getMovementRetourAutreDechargeFailure, getMovementRetourAutreDechargeStart, getMovementRetourAutreDechargeSuccess, getMovementsFailure, getMovementsStart, getMovementsSuccess, loadDechargeFailure, loadDechargeStart, loadDechargeSuccess, submitDechargeFailure, submitDechargeStart, submitDechargeSuccess, submitRetourAutreDechargeFailure, submitRetourAutreDechargeStart, submitRetourAutreDechargeSuccess, updateMovementDechargeFailure, updateMovementDechargeStart, updateMovementDechargeSuccess } from "./MovementActions";


const axiosInstance = axios.create({
    baseURL: API_URL,
});

export const getMovements = async (dispatch, pageSize, page, idMovement, typeMovement, typeAction, agenceId, dateMovement) => {
    let movementFilter = { idMovement, typeMovement, typeAction, agenceId, dateMovement };
    dispatch(getMovementsStart());
    try {
        const res = await axiosInstance.post(`/admin/movements?pageSize=${pageSize}&page=${page}`, movementFilter, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getMovementsSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(getMovementsFailure(err.response.data.message))
        } else {
            dispatch(getMovementsFailure("Unkown Error"))
        }
    }
}

export const addMovement = async (dispatch, agence, montant, type, typeAction, list, motif) => {
    dispatch(addMovementStart());
    let small_list = list.map(item => item.Envoi.id);
    let movement = { agence, montant, type, typeAction, small_list, motif };
    try {
        const res = await axiosInstance.post(`/admin/movements/add`, movement, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(addMovementSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(addMovementFailure(err.response.data.message))
        } else {
            dispatch(addMovementFailure("Unkown Error"))
        }
    }
}

export const addMovementInvoice = async (dispatch, montant, invoiceId, motif, file) => {
    dispatch(addMovementStart());

    let movement = { montant, invoiceId, motif };
    /** Begin Upload File **/
    if (file) {
        const data = new FormData();
        const fileName = Date.now() + file.name;
        data.append("name", fileName);
        data.append("file", file);
        movement.img = fileName;
        try {
            await axiosInstance.post("/uploadEncaisse", data);
        } catch (err) { 
            if (err.response) {
                dispatch(addMovementFailure(err.response.data.message));
            } else {
                dispatch(addMovementFailure("Unkown Error"));
            }
        }
    }
    /** End Upload File **/
    
    try {
        const res = await axiosInstance.post(`/admin/movements/addFromFacture`, movement, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(addMovementSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(addMovementFailure(err.response.data.message))
        } else {
            dispatch(addMovementFailure("Unkown Error"))
        }
    }
}

export const loadDecharge = async (dispatch, pageSize, page, clientOrEntrepriseId, entrepriseId, username) => {
    dispatch(loadDechargeStart());
    let reqBody = {};
    if (clientOrEntrepriseId === 1) {
        reqBody = {
            clientOrEntreprise: clientOrEntrepriseId,
            entrepriseId
        }
    } else if (clientOrEntrepriseId === 2) {
        reqBody = {
            clientOrEntreprise: clientOrEntrepriseId,
            username
        }
    }
    try {
        const res = await axiosInstance.post(`/admin/movements/loading?pageSize=${pageSize}&page=${page}`, reqBody, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(loadDechargeSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(loadDechargeFailure(err.response.data.message));
        } else {
            dispatch(loadDechargeFailure("Unkown Error"));
        }
    }
}

export const updateDecharge = async (dispatch, id, motif, file) => {
    dispatch(updateMovementDechargeStart());
    let reqBody = { id, motif };

    /** Begin Upload File **/
    if (file) {
        const data = new FormData();
        const fileName = Date.now() + file.name;
        data.append("name", fileName);
        data.append("file", file);
        reqBody.image = fileName;
        try {
            await axiosInstance.post("/uploadDecharge", data);
        } catch (err) { 
            if (err.response) {
                dispatch(updateMovementDechargeFailure(err.response.data.message));
            } else {
                dispatch(updateMovementDechargeFailure("Unkown Error"));
            }
        }
    }
    /** End Upload File **/

    try {
        const res = await axiosInstance.post(`/admin/movements/editDecharge`, reqBody, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(updateMovementDechargeSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(updateMovementDechargeFailure(err.response.data.message));
        } else {
            dispatch(updateMovementDechargeFailure("Unkown Error"));
        }
    }
}

// Submit decharge for Retour/Autre
export const submitDechargeRetourAutre = async (dispatch, montant, motif, file) => {
    dispatch(submitRetourAutreDechargeStart());
    let reqBody = { montant, motif }
      /** Begin Upload File **/
    if (file) {
        const data = new FormData();
        const fileName = Date.now() + file.name;
        data.append("name", fileName);
        data.append("file", file);
        reqBody.img = fileName;
        try {
            await axiosInstance.post("/uploadDecharge", data);
        } catch (err) { 
            if (err.response) {
                dispatch(submitRetourAutreDechargeFailure(err.response.data.message));
            } else {
                dispatch(submitRetourAutreDechargeFailure("Unkown Error"));
            }
        }
    }
    /** End Upload File **/

    try {
        const res = await axiosInstance.post(`/admin/movements/submitRetourAutreDecharge`, reqBody, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(submitRetourAutreDechargeSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(submitRetourAutreDechargeFailure(err.response.data.message));
        } else {
            dispatch(submitRetourAutreDechargeFailure("Unkown Error"));
        }
    }
}

// Submit decharge for Client/Entreprise
export const submitDecharge = async (dispatch, clientOrEntrepriseId, entrepriseId, username, sumMontant, motif, file) => {
    dispatch(submitDechargeStart());
    let reqBody = {};
    if (clientOrEntrepriseId === 1) {
        reqBody = {
            clientOrEntreprise: clientOrEntrepriseId,
            entrepriseId,
            sumMontant,
            motif
        }
    } else if (clientOrEntrepriseId === 2) {
        reqBody = {
            clientOrEntreprise: clientOrEntrepriseId,
            username,
            sumMontant,
            motif
        }
    }

    /** Begin Upload File **/
    if (file) {
        const data = new FormData();
        const fileName = Date.now() + file.name;
        data.append("name", fileName);
        data.append("file", file);
        reqBody.img = fileName;
        try {
            await axiosInstance.post("/uploadDecharge", data);
        } catch (err) { 
            if (err.response) {
                dispatch(submitDechargeFailure(err.response.data.message));
            } else {
                dispatch(submitDechargeFailure("Unkown Error"));
            }
        }
    }
    /** End Upload File **/

    try {
        const res = await axiosInstance.post(`/admin/movements/submitDecharge`, reqBody, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(submitDechargeSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(submitDechargeFailure(err.response.data.message));
        } else {
            dispatch(submitDechargeFailure("Unkown Error"));
        }
    }
}

// Get decharge Retour/Autre
export const getMovementRetourAutreDecharge = async (dispatch, id) => {
    dispatch(getMovementRetourAutreDechargeStart());
    try {
        const res = await axiosInstance.post(`/admin/movements/detailRetourAutre`, { id }, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getMovementRetourAutreDechargeSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(getMovementRetourAutreDechargeFailure(err.response.data.message));
        } else {
            dispatch(getMovementRetourAutreDechargeFailure("Unkown Error"));
        }
    }
}

// Get decharge Client/Entreprise
export const getMovementDecharge = async (dispatch, pageSize, page, id) => {
    dispatch(getMovementDechargeStart());
    try {
        const res = await axiosInstance.post(`/admin/movements/detail?pageSize=${pageSize}&page=${page}`, { id }, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getMovementDechargeSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(getMovementDechargeFailure(err.response.data.message));
        } else {
            dispatch(getMovementDechargeFailure("Unkown Error"));
        }
    }
}

export const getMovementEncaissement = async (dispatch, pageSize, page, id) => {
    dispatch(getMovementEncaissementStart());
    try {
        const res = await axiosInstance.post(`/admin/movements/detailEncaissement?pageSize=${pageSize}&page=${page}`, { id }, {
            headers: {
                token: `nweadmin ` + JSON.parse(localStorage.getItem('user')).accessToken
            }
        });
        dispatch(getMovementEncaissementSuccess(res.data));
    } catch (err) {
        if (err.response) {
            dispatch(getMovementEncaissementFailure(err.response.data.message));
        } else {
            dispatch(getMovementEncaissementFailure("Unkown Error"));
        }
    }
}